/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TaskResultCache } from './taskResultCache';

/**
 * Serializer for CategoryResultCache.  When using CategoryResultCacheSerializer as nested serializer in ChildResultCacheSerializer, field 'child_result' is not required (because child_result is created in create() method). Temporarily fix is set child_result as required=False permanently.
 */
export interface CategoryResultCache { 
    categoryUuid: string;
    maxScore?: string;
    score?: string;
    percent?: string;
    evaluationTitle?: string;
    evaluationCode?: number;
    evaluationTextColor?: string;
    evaluationBackgroundColor?: string;
    order?: number;
    childResult?: number;
    taskResults?: Array<TaskResultCache>;
}